import React from "react"
import PropTypes from "prop-types"
import { FadeInAnimation } from "./Commons/Animations"

const propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
  twitter: PropTypes.string,
  phone: PropTypes.string,
  instagram: PropTypes.string,
  showCard: PropTypes.func,
}
const ContactCard = ({
  name,
  email,
  twitter,
  phone,
  instagram,
  showCard,
}) => {
  return (
    <FadeInAnimation
      className="transition ease-in-out duration-300 fixed z-10 flex justify-center items-center left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 h-full w-full"
    >
      <div
        className="h-full bg-black opacity-70 w-full absolute"
        onClick={showCard}
      />
      <FadeInAnimation
        className="md:w-1/3 w-11/12 p-4 rounded-2xl bg-white z-20 transition ease-in-out duration-75"
        direction="up"
        delay={0}
      >
        <h1 className="text-center font-medium text-2xl pb-6 border-b border-gray-400">
          Contact {name}
        </h1>
        <div className="p-2 mt-1 md:flex block justify-around">
          <div>
            <div className="my-6">
              <p className="text-gray-500 text-sm">Email address</p>
              <p>
                <a
                  href={`mailto:${email}`}
                  className="text-base font-medium"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {email}
                </a>
              </p>
            </div>
            <div className="my-6">
              <p className="text-gray-500 text-sm">Twitter</p>
              <p>
                <a
                  href={`https://twitter.com/${twitter}`}
                  className="text-base font-medium"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {twitter}
                </a>
              </p>
            </div>
          </div>
          <div>
            <div className="my-6">
              <p className="text-gray-500 text-sm">Phone number</p>
              <p>
                <a
                  href={`tel:${phone}`}
                  className="text-base font-medium"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {phone}
                </a>
              </p>
            </div>
            <div className="my-6">
              <p className="text-gray-500 text-sm">Instagram</p>
              <p>
                <a
                  href={`https://instagram.com/${instagram}`}
                  className="text-base font-medium"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {instagram}
                </a>
              </p>
            </div>
          </div>

        </div>
      </FadeInAnimation>
    </FadeInAnimation>
  )
}
ContactCard.propTypes = propTypes
export default ContactCard
